import * as React from "react";
import Panel from "../Panel";
import ClientAssessments from "../../containers/Client/ClientInfo/ClientAssessments";

interface Props {
  onClose: () => void;
  clientId: number;
}

function AssessmentHistoryPanel({ onClose, clientId }: Props): JSX.Element {
  return (
    <Panel onClose={onClose}>
      <ClientAssessments clientId={clientId} />
    </Panel>
  );
}

export default AssessmentHistoryPanel;
